import { combineReducers } from 'redux';
import { batchRecordReducer } from '../BatchRecord';

const combinedReducer = combineReducers({ batchRecords: batchRecordReducer });

export default combinedReducer;
